import { DeviceStatus } from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";
import { convertMapToOpts } from "../shared/index.ts";

export const DeviceStatusOptions = convertMapToOpts(
  DeviceStatus,
  ([_, value]) => toTitleCaseString(value)
);
